import { TFunction } from 'i18next'
import MssqlCachingRestService from '../rest/MssqlCachingRestService'

class MssqlCachingService {
  static async getCacheConfig(policyId: number) {
    return MssqlCachingRestService.getCacheConfig(policyId)
  }

  static async setCacheConfig(userCache: any, policyId: number, t: TFunction) {
    try {
      const cacheConfig = {
        policyId,
        cacheUserList: Object.keys(userCache).map((user) => {
          return { name: user, size: userCache[user] }
        }),
      }
      await MssqlCachingRestService.setCacheConfig(cacheConfig)
      return t('mssqlAdapter.setCacheConfigSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default MssqlCachingService
